import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FaHome } from 'react-icons/fa';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <NotFoundContainer>
      <NotFoundContent>
        <NotFoundCode>404</NotFoundCode>
        <NotFoundTitle>Page Not Found</NotFoundTitle>
        <NotFoundText>
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </NotFoundText>
        <HomeButton to="/">
          <FaHome /> {t('common.back')}
        </HomeButton>
      </NotFoundContent>
    </NotFoundContainer>
  );
};

const NotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - var(--header-height) - var(--footer-height));
  padding: 2rem;
  background-color: var(--background-color);
`;

const NotFoundContent = styled.div`
  text-align: center;
  max-width: 600px;
`;

const NotFoundCode = styled.h1`
  font-size: 8rem;
  font-weight: 700;
  color: var(--primary-color);
  margin: 0;
  line-height: 1;
  
  @media (max-width: 768px) {
    font-size: 6rem;
  }
`;

const NotFoundTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: var(--text-color);
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const NotFoundText = styled.p`
  font-size: 1.125rem;
  color: var(--text-light);
  margin-bottom: 2rem;
`;

const HomeButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--primary-color);
  color: var(--white);
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-md);
  transition: all var(--transition-fast) ease;
  
  &:hover {
    background-color: var(--secondary-color);
    transform: translateY(-3px);
    box-shadow: var(--shadow-md);
  }
`;

export default NotFoundPage;